module.exports = __webpack_public_path__ + "static/media/2017-Scrum-Guide-US.a9dc0589.pdf";